export const getPaginatedData = (data, currentPage, pageSize) => {
  return data.slice(currentPage * pageSize, currentPage * Number(pageSize) + Number(pageSize)) ?? []
}
